<app-navbar title="Dodawanie wydarzenia">
	<button class="btn btn-primary me-2" (click)="submit()">Zapisz</button>
	<a routerLink="/tourism-calendar/" class="btn btn-danger"> <i class="far fa-calendar-alt"></i> Kalendarz </a>
</app-navbar>

<form class="container my-4">
	<div class="form-floating mb-3">
		<input
			class="form-control"
			id="name"
			name="name"
			[(ngModel)]="event.name"
			[ngClass]="{ error: this.errors.name }"
		/>
		<label for="name">Nazwa wydarzenia</label>
	</div>
	<div class="row mb-3">
		<div class="col-6">
			<div class="form-floating">
				<input
					type="datetime-local"
					class="form-control"
					name="date_from"
					id="date_from"
					[ngModel]="event.date_from | date: 'yyyy-MM-ddTHH:mm'"
					(ngModelChange)="changeDateFrom($event)"
					[ngClass]="{ error: this.errors.date_from }"
				/>
				<label for="date_from">Data rozpoczęcia</label>
			</div>
		</div>
		<div class="col-6">
			<div class="form-floating">
				<input
					type="datetime-local"
					class="form-control"
					name="date_to"
					id="date_to"
					[ngModel]="event.date_to | date: 'yyyy-MM-ddTHH:mm'"
					(ngModelChange)="event.date_to = $event; calculateDateDeadline()"
					[ngClass]="{ error: this.errors.date_to }"
				/>
				<label for="date_to">Data zakończenia</label>
			</div>
		</div>
	</div>
	<div class="mb-3">
		<app-tourism-events-vehicle-add
			[min]="event.date_from"
			[max]="event.date_to"
			[vehicles]="vehicles"
			[editable]="lockEdit"
			[alreadyAddedVehicles]="event.vehicles"
			(emitVehiclesArray)="setVehicles($event)"
		></app-tourism-events-vehicle-add>
	</div>
	<div class="mb-3">
		<label class="form-label" for="owner">Opiekun</label>
		<ng-select
			id="owner"
			name="owner"
			[(ngModel)]="event.owner"
			placeholder="(wybierz)"
			bindLabel="name"
			[multiple]="true"
			[ngClass]="{ error: this.errors.owner }"
			required
			class="px-0"
		>
			@for (user of users; track user.id) {
				<ng-option [value]="user.id">{{ user.name }}</ng-option>
			}
		</ng-select>
	</div>
	<div class="form-floating mb-3">
		<select class="form-select" id="status" name="status" [(ngModel)]="event.status" disabled>
			@for (status of statuses; track status.id) {
				<option value="{{ status.id }}">
					{{ status.name }}
				</option>
			}
		</select>
		<label for="status">Status</label>
	</div>
</form>
